export const MOUNT = 'mount'; // Don't change this one, it's a default event emitted by picoapp

export const ACTION_DIALOG_CLOSE = 1;
export const ACTION_DIALOG_OPEN = 2;
export const ANNOUNCEMENT_HIDE = 3;
export const BFCM_CLOCK_NEWSLETTER_SECTION_READY = 4;
export const BFCM_TEXT_VIDEO_STYLES_UPDATE = 5;
export const CART_CHANGED = 6;
export const CART_LOADING = 7;
export const CART_STAGE_UPDATE = 8;
export const CART_UPDATING = 9;
export const COLLECTION_ACTIVATE_BACK_TO_TOP = 10;
export const COLLECTION_DEACTIVATE_BACK_TO_TOP = 11;
export const COLLECTION_FILTER_OPTION_CHECK = 12;
export const COLLECTION_FILTER_OPTION_UNCHECK = 13;
export const COLLECTION_FILTER_RESET = 14;
export const COLLECTION_FILTER_SUBMIT = 15;
export const COLLECTION_FILTER_UPDATE = 16;
export const COLLECTION_GRID_APPEND = 17;
export const COLLECTION_GRID_LOADING = 18;
export const COLLECTION_GRID_PREPEND = 19;
export const COLLECTION_GRID_RENDER = 20;
export const COLLECTION_GRID_UPDATE = 21;
export const COLLECTION_NEXT_PAGE = 22;
export const COLLECTION_PAGINATION_UPDATE = 23;
export const COLLECTION_PREVIOUS_PAGE = 24;
export const COLLECTION_PRODUCT_CLICK = 25;
export const COLLECTION_PRODUCT_FOCUSED = 26;
export const COLLECTION_RUN_BACK_TO_TOP = 27;
export const COLLECTION_SUBMIT_FILTER = 28;
export const COLLECTION_UPDATE = 29;
export const COLLECTION_UPDATE_STYLES = 30;
export const COUNTDOWN_FINISHED = (date) => `31:${date}`;
export const COUNTDOWN_UPDATE = (date) => `32:${date}`;
export const DOCUMENT_CLICK = 33;
export const DRAWER_CLOSE = 34;
export const DRAWER_OPEN = 35;
export const DRAWER_TOGGLE = 36;
export const FEATURE_TAB_TOGGLE = 37;
export const HEADER_MOBILE_CLICK = 38;
export const MODAL_CLOSE = 39;
export const MODAL_CLOSE_ALL = 40;
export const MODAL_CLOSED = 41;
export const MODAL_OPEN = 42;
export const MODAL_TOGGLE = 43;
export const MOUNT_COMPONENTS = 44;
export const OOS_FORM_MOUNT = 45;
export const OOS_FORM_UNMOUNT = 46;
export const PRODUCT_FORM_SCROLL_INTO_VIEW = 47;
export const PRODUCT_FORM_UPDATE_VARIANT = 48;
export const PRODUCT_ITEM_QUICK_SHOP_TOGGLE = 49;
export const PRODUCT_STICKY_FORM_HIDE = 50;
export const PRODUCT_STICKY_FORM_SHOW = 51;
export const REGISTER_COUNTDOWN = 52;
export const UNREGISTER_COUNTDOWN = 53;
export const SEARCH_QUERY = 54;
export const SEARCH_QUERY_SUGGESTION = 55;
export const SEARCH_RESET = 56;
export const SEARCH_RESULT = 57;
export const SEARCH_RESULTS = 58;
export const SEARCH_SUBMIT = 59;
export const SEARCH_SUGGESTIONS = 60;
export const STICKY_FOOTER_TOGGLE_SECTION = 61;
export const THEME_CART_UPDATED = 62;
export const THEME_WISHLIST_UPDATED = 63;
export const VIDEO_ENTER_FULLSCREEN = 64;
export const VIDEO_EXIT_FULLSCREEN = 65;
export const VIDEO_PLAY = 66;
export const VIDEO_STOP = 67;
export const INIT_MOVEABLE_CONTENT = 68;
export const ABOUT_SECTION_IN_VIEW = 69;
export const ABOUT_SCROLL_TO_START = 70;
export const UPDATE_VISIBLE_SCREEN_HEIGHT = 71;
export const SHOW_FIT_OPTIONS = 71;
